import type { SearchResponse } from '@do/data-transfer-objects/dist/shop-api';

import { Api } from '@shared/api';

export class SearchApi extends Api {
  public async search({
    search,
    institutions,
    limit,
    offset,
  }: {
    search: string;
    institutions: string;
    limit: number;
    offset: number;
  }): Promise<SearchResponse> {
    const searchParams = new URLSearchParams();

    searchParams.append('search', search);
    searchParams.append('institutions', institutions);
    searchParams.append('limit', limit.toString());
    searchParams.append('offset', offset.toString());

    const response = await this.fetch(`${this.baseUrl}/search?${searchParams}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.json();
  }
}
